import React, { Component } from 'react'
import { connect } from 'react-redux'
import styles from '../../../styles/3ds2/main.module.css'
import CavvLookUpSample from '../samples/CavvLookUpSample'
import { makeCavvLookupRequest, challengeMade, toggleChallengeIfram} from '../../../actions/threeDSTwoActions'
import { updateCres } from '../../../actions/commonActions'
import Iframe from 'react-iframe'
import { _3DS2, _DOTNET, _JAVA, _PHP } from '../../../actions/types'


var isIE = /*@cc_on!@*/false || !!document.documentMode;
const scrollToRef = (ref) => window.scrollTo(0, ref.current.scrollIntoView())

class HandlingChallengeFlow extends Component {
    state = {
        modelOpen: false,
        iframeOpen: false,
        iframeRef: React.createRef(),
        topRef: React.createRef(),
        showError: false,
        showSuccess: false,
        showWarning: false,
    }

    componentDidMount() {
        window.addEventListener("message", this.receiveMessage, false);
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.state.showSuccess !== prevState.showSuccess && this.state.showSuccess === true) {
            scrollToRef(this.state.topRef)
        }
        if(this.state.iframeOpen !== prevState.iframeOpen) {
            this.props.toggleChallengeIfram(this.state.iframeOpen);
        }
    }

    receiveMessage = (event) => {
        const message = event.data.message;    
        switch (message) {
            case 'cresData':
                this.props.updateCres({ featureId: _3DS2, cres: event.data.value});
                this.setState({ iframeOpen: false, showSuccess: true });
                break;
            default:
                break;
        }
    }

    renderIfram() {
        if(this.state.iframeOpen) {
            return (
                <div className="iframeChallenge">
                    <Iframe url=""
                            width="100%"
                            height="100%"
                            name="myIfram"
                            display="initail"
                            frameBorder="0"
                            position="relative"/>
                </div>
            );
        }
    }

    onSubmitClick() {
        this.setState({ modelOpen: false, iframeOpen: true });
        this.props.challengeMade();
        scrollToRef(this.state.iframeRef);
    }

    renderButton() {
        const { cres, storeId, apiToken, loading, cavvLookupSuccess } = this.props;

        if(cres === 'null' || loading || cavvLookupSuccess) {
            return (
                <div className="disabledButton">
                    Cavv Lookup Request
                </div>
            );
        }
        else {
            return (
                <div className="requestButton" onClick={() => this.props.makeCavvLookupRequest({ storeId, apiToken })}>
                    Cavv Lookup Request
                </div>
            );
        }
    }

    renderMessage() {
        if(this.state.showError) {
            return (
                <div style={{ marginTop:'4vh', marginRight: '3vw', marginLeft: '1vw',backgroundColor:'#ffe6e6', color:'#b30000', padding:'1vw', borderRadius:'10px', border:'1px solid #ff8080', lineHeight: '3vh'}}><strong>Error!</strong><br />You can make a challenge only when you get a TransStatus = “C” in your 3DS Authentication Response.</div>
            );
        }
        else if(this.state.showSuccess) {
            return (
                <div style={{ marginTop:'4vh', marginRight: '3vw', marginLeft: '1vw',backgroundColor:'#d6f5d6', color:'#196719', padding:'1vw', borderRadius:'10px', border:'1px solid #6fdc6f', lineHeight: '3vh'}}><strong>Challenge Accepted!</strong><br />The returned “cres” has been inserted to the sample code below, you can make a Cavv Lookup Request now.</div>
            );
        }
        else if(this.state.showWarning && this.props.authRequestNeeded) {
            return (
                <div style={{ marginTop:'4vh', marginRight: '3vw', marginLeft: '1vw',backgroundColor:'#ffe6e6', color:'#b30000', padding:'1vw', borderRadius:'10px', border:'1px solid #ff8080', lineHeight: '3vh'}}><strong>Error!</strong><br />You need to make a new 3DS authentication request.</div>
            );
        }
        else {
            return (
                <h4 ref={this.state.iframeRef} style={{ color: '#fff'}}>iframe</h4>
            );
        }
    }

    onMakeChallengeClick() {
        const { challengeData } = this.props;

        if(challengeData === 'null') {
            this.setState({ showError: true, modalOpen: false, showSuccess: false });
        }
        else if(this.props.authRequestNeeded) {
            this.setState({ showWarning: true, iframeOpen: false ,modalOpen: false, showSuccess: false });
        }
        else {
            this.setState({ modelOpen: true, showError: false, showSuccess: false });
        }
    }

    renderInteractiveTool() {
        const { modalClose, modalContent, close, modalOpen } = styles;
        const { challengeData, challengeURL } = this.props;

        return (
            <div ref={this.state.topRef} className="stepMainContainer">
                <p style={{ marginBottom: '4vh' }}>Use the button below to try making a challenge:</p>
                <div className="requestButton" onClick={() => this.onMakeChallengeClick()}>
                    Make Challenge
                </div>

                {this.renderMessage()}
                {this.renderIfram()}

                <div className={this.state.modelOpen ? modalOpen : modalClose } id="myModal" ref="myModal" style={{backgroundColor: isIE ? '#cacaca' : 'rgb(0,0,0,0.5)'}}>
                    <span className={close} onClick={() => this.setState({ modelOpen: false })}>&times;</span>
                    <form method="POST" action={challengeURL} className={modalContent} target="myIfram">
                        <table style={{ marginTop: '5vh', marginBottom: '2vw', marginLeft: '1vw', width: '40vw', height: '20vh' }}>
                            <tr>
                                <td style={{ color: '#000', width: '5vw', textAlign: 'left', paddingLeft: '1vw'}}><h3>creq:</h3></td>
                                <td style={{ padding: '2vw', width: '20vw' }}><textarea readOnly rows="5" cols="50" name="creq" style={{ height: '18vh', resize: 'none', maxWidth: '28vw', overflowY: 'auto' }} type='text' value={challengeData} /></td>
                            </tr>
                        </table>
                        <input type='submit' value='Submit' className="resetButton" style={{marginLeft: '1.2vw'}} onClick={() => this.onSubmitClick()}/>
                    </form>
                </div>

                <h3>Sample Cavv Lookup Request</h3>
                <CavvLookUpSample />
                {this.renderButton()}
            </div>
        );
    }

    renderDocument() {
        const { progLangId } = this.props;

        return (
            <div className="stepPageContainer">
                <div>
                    <span className="stepPageTitle"><b>Handling The Challenge Flow</b></span>
                    <p style={{ marginTop: '5vh', marginBottom: '4vh' }}>If you get a TransStatus = “C” in your threeDSAuthentication Response, then a form must be built and POSTed to the URL provided.<br/><br/>The form can be dynamically generated and added to the DOM and submitted or created and submitted in a manner that suits your environment. This can be built as a full page redirect or presented as an inline iframe or as a lightbox.<br/><br/>If you wish for this to be loaded inside a defined space it must conform to the size specified in the challengeWindowSize from the request. The “action” is retrieved from the ChallengeURL and the “<strong>creq</strong>” field is retrieved from the ChallengeData.<br/><br/>Below is a sample of a basic static form to help visualize the data and fields that need to be submitted.</p>
                    <div>
                        <code>{`<form method="POST" action="https://3dsurl.example.com/do3DS">`}</code><br />
                        <code style={{ marginLeft: '1.5vw'}}>{`<input name="creq" value="thisissamplechallengedata1234567890">`}</code><br />
                        <code>{`</form>`}</code>
                    </div>

                    <h3 style={{color: '#00a1cb'}}>Cavv Lookup Request – mpiCavvLookup</h3>
                    <p>(Challenge Flow Only)</p>
                    <p style={{ marginTop: '2vh', marginBottom: '4vh' }}>In the challenge flow, the 3DS server will POST a “cres” value back to the notificationURL provided in the threeDSAuthentication request once the cardholder has completed the challenge.  The “cres” is then posted to the Moneris 3DS server in the CavvLookup request, the response to this request will include the result of the challenge, which will include the eci and the cavv if the challenge was successful.</p>

                    <p><b>Cavv Lookup Request transaction object definition</b></p>
                    {(() => {
                    switch(progLangId) {
                        case _DOTNET:
                            return <code>MpiCavvLookup mpiCavvLookup = new MpiCavvLookup();</code>
                        case _JAVA:
                            return <code>MpiCavvLookup mpiCavvLookup = new MpiCavvLookup();</code>
                        case _PHP:
                            return <code>$mpiCavvLookup = new MpiCavvLookup();</code>
                        default:
                            return null
                        }
                    })()}

                    <p style={{ marginTop: '5vh' }}>HttpsPostRequest object for Cavv Lookup Request transaction</p>
                    {(() => {
                        switch(progLangId) {
                            case _DOTNET:
                                return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.SetTransaction(mpiCavvLookup);</code>
                            case _JAVA:
                                return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.setTransaction(mpiCavvLookup);</code>
                            case _PHP:
                                return <code>$mpgRequest = new mpgRequest($mpgTxn);<br />$mpgTxn = new mpgTransaction($mpiCavvLookup);</code>
                            default:
                                return null
                        }
                    })()}

                    <h3 style={{ marginTop: '10vh'}}>Core connection object fields (all API transactions)</h3>
                    <table>
                        <th>Variable Name</th>
                        <th>Type and Limits</th>
                        <th>Description</th>

                        <tr>
                            <td>store ID</td>
                            <td><i>String</i><br /><br /> N/A</td>
                            <td>Unique identifier provided by Moneris upon merchant account setup</td>
                        </tr>
                        <tr>
                            <td>API token</td>
                            <td><i>String</i><br /><br /> N/A</td>
                            <td>Unique alphanumeric string assigned by Moneris upon merchant account activation</td>
                        </tr>
                    </table>

                    <h3 style={{ marginTop: '10vh'}}>Cavv Lookup Request transaction request fields – Required</h3>
                    <table>
                        <th>Variable Name</th>
                        <th>Type and Limits</th>
                        <th>Set Method</th>

                        <tr>
                            <td>cres</td>
                            <td><i>String</i><br /><br /> 200-character alphanumeric</td>
                            {(() => {
                            switch(progLangId) {
                                case _DOTNET:
                                    return <td><code>mpiCavvLookup.SetCRes(cres);</code></td>
                                case _JAVA:
                                    return <td><code>mpiCavvLookup.setCRes(cres);</code></td>
                                case _PHP:
                                    return <td><code>{"$mpiCavvLookup->setCRes($cres);"}</code></td>
                                default:
                                    return null
                                }
                            })()}
                        </tr>
                    </table>
                </div>
            </div>
        )
    }

    render() {
        const { mode, selectedStep } = this.props;
        if(mode === 'interactive_tool' && selectedStep === 5)
            return this.renderInteractiveTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { storeId, apiToken, challengeData, challengeURL, cres } = state.threeDSTwo.main.config;
    const { loading, authRequestNeeded, cavvLookupSuccess } = state.threeDSTwo.main;
    const { mode } = state.common.sideNav;
    const { selection } = state.threeDSTwo.stepsList;
    return { cavvLookupSuccess, authRequestNeeded, selectedStep: selection, mode, loading, storeId, apiToken, challengeData, challengeURL, cres, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {makeCavvLookupRequest, updateCres, challengeMade, toggleChallengeIfram})(HandlingChallengeFlow)

